import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/staff.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStaff from "../dialog/MdlSelectMultipleStaff";
import BackButton from "../ChildComponent/BackButton";

const StaffOfferLetter = () => {
  const { document_type } = useParams();
  
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStaff, setIsOpenSelectStaff] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [mSelectedStaff, setMSelectedStaff] = useState([]);
  const [mOfferLetterSamples, setMOfferLetterSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
  const DOCUMENT_TYPE = document_type || "offer_letter";

  const [height, setHeight] = useState("600px");
  const iframeRef = useRef(null);

  useEffect(() => {
    getOfferLetterSamples();
    
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getOfferLetterSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getPrintableSample.php`;

    axios
      .get(URL, { params: { school_code: SCHOOL_CODE, document_type: DOCUMENT_TYPE } })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && response.data?.length > 0) {
          setMOfferLetterSamples(response.data);
          setSample(SELECTED_SAMPLE_POSITION, response.data);
        } else {
          myToast.notify_warning(response.api_remark || "No offer letter templates found");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const setSample = (selected_sample_position, samples = mOfferLetterSamples) => {
    const sample = samples[selected_sample_position];
    if (sample) {
      setFILE_NAME(sample.file_name);
      setFILE_DIRECTORY(sample.file_directory);
      setSELECTED_SAMPLE_ID(sample.sample_id);
      getColorOptions(selected_sample_position, samples, sample.file_name, sample.file_directory, sample.sample_id);
    }
  };

  const getColorOptions = (
    selected_sample_position,
    samples = mOfferLetterSamples,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID
  ) => {
    const colorOptions = samples[selected_sample_position]?.color_options || [];
    setMColorOption(colorOptions);
    setColorOptions(SELECTED_COLOR_POSITION, colorOptions, fileName, fileDirectory, sampleId);
  };

  const setColorOptions = (
    selected_position_color_option,
    colorOptions = mColorOption,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID
  ) => {
    const selectedColor = colorOptions[selected_position_color_option];
    const colorOptionId = selectedColor ? selectedColor.color_option_id : "";
    setCOLOR_OPTION_ID(colorOptionId);

    if (mSelectedStaff.length > 0) {
      setFileUrL(mSelectedStaff, fileName, fileDirectory, sampleId, colorOptionId);
    }
  };

  const setFileUrL = (
    staffList = mSelectedStaff,
    fileName = FILE_NAME,
    fileDirectory = FILE_DIRECTORY,
    sampleId = SELECTED_SAMPLE_ID,
    colorOptionId = COLOR_OPTION_ID
  ) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const currentSession = SessionManager.getCurrentSession();
    const sessionId = Array.isArray(currentSession) ? currentSession[0]?.session_id : currentSession?.session_id || "";
    const mStaffIds = staffList.map((s) => s.staff_id);

    const url = `${process.env.REACT_APP_SERVER_NAME}${fileDirectory}${fileName}?staff_ids=${encodeURIComponent(JSON.stringify(mStaffIds))}&session_id=${sessionId}&sample_id=${sampleId}&system_code=${process.env.REACT_APP_SYSTEM_CODE}&color_option_id=${colorOptionId}&school_code=${SCHOOL_CODE}`;

    console.log("Offer Letter URL:", url);
    setFILE_URL(url);
  };

  const changeColor = (index) => {
    setSELECTED_COLOR_POSITION(index);
    setShowPreview(true);
    setColorOptions(index, mColorOption, FILE_NAME, FILE_DIRECTORY, SELECTED_SAMPLE_ID);
  };

  const changeSample = (position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setShowPreview(true);
    setSample(position);
  };

  const SelectStaff = () => {
    setIsOpenSelectStaff(true);
  };

  const HandleCloseSelectStaff = () => {
    setIsOpenSelectStaff(false);
  };

  const HandleSelectedStaff = (selectedStaffList) => {
    const staffList = selectedStaffList || [];
    setIsOpenSelectStaff(false);
    setShowPreview(true);
    setMSelectedStaff(staffList);
    setFileUrL(staffList);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
    <div className="content staff-offer-letter">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#" style={{ color: COLORS.white }}>
                Staff Offer Letter
              </a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="page-card">
        {/* Modern Header Section */}
        <div className="header-section">
          <div className="header-content">
            <h5>Staff Offer Letter</h5>
            <small>Generate professional offer letters for staff members</small>
          </div>
          <div className="header-icon">
            <i className="fa fa-file-text"></i>
          </div>
        </div>

        {/* Staff Selection Section */}
        <div style={{ display: "flex", gap: "16px", margin: "16px 20px 0 20px" }}>
          <div style={{ flex: "1" }}>
            <div className="selection-section select-recipients">
              <h5 className="section-title">
                <i className="fa fa-users" style={{ marginRight: "6px" }} />
                Select Staff Members
              </h5>
              {mSelectedStaff.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
                  <div style={{ 
                    display: "flex", 
                    flexWrap: "wrap", 
                    gap: "8px", 
                    justifyContent: "center",
                    maxWidth: "100%"
                  }}>
                    {mSelectedStaff.slice(0, 5).map((staff, index) => (
                      <span 
                        key={index} 
                        style={{
                          background: "linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)",
                          color: "#fff",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}
                      >
                        {staff.staff_name}
                      </span>
                    ))}
                    {mSelectedStaff.length > 5 && (
                      <span style={{
                        background: "#e5e7eb",
                        color: "#374151",
                        padding: "6px 12px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600"
                      }}>
                        +{mSelectedStaff.length - 5} more
                      </span>
                    )}
                  </div>
                  <button
                    className="selection-button"
                    onClick={SelectStaff}
                  >
                    <i className="fa fa-edit" />
                    Change Selection ({mSelectedStaff.length})
                  </button>
                </div>
              ) : (
                <div className="selection-buttons">
                  <button
                    className="selection-button"
                    onClick={SelectStaff}
                  >
                    <i className="fa fa-user-plus" />
                    Select Staff Members
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Templates Section */}
        <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-file-text" style={{ marginRight: "6px" }} />
            Offer Letter Templates
          </h5>
          <div className="templates-grid">
            {mOfferLetterSamples.map((item, index) => (
              <div
                key={index}
                className={`template-item ${SELECTED_SAMPLE_POSITION === index ? 'active' : ''}`}
                onClick={() => changeSample(index)}
              >
                <i className="fa fa-file-text template-icon"></i>
                <div className="template-name">{item.sample_name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Color Options Section */}
        {mColorOption.length > 0 && (
          <div className="selection-section" style={{ margin: "16px 20px 0 20px" }}>
            <h5 className="section-title">
              <i className="fa fa-paint-brush" style={{ marginRight: "6px" }} />
              Color Options
            </h5>
            <div className="color-options">
              {mColorOption.map((item, index) => {
                const [color1, color2] = item.sample_color_code.split("_");
                return (
                  <div
                    key={index}
                    className={`color-option ${SELECTED_COLOR_POSITION === index ? 'active' : ''}`}
                    onClick={() => changeColor(index)}
                  >
                    <div className="color-display">
                      <div style={{ backgroundColor: color1 }}></div>
                      <div style={{ backgroundColor: color2 }}></div>
                    </div>
                    <div className="color-name">{item.sample_color_name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Preview Section */}
        <div className="preview-section" style={{ margin: "16px 20px 20px 20px" }}>
          <h5 className="section-title">
            <i className="fa fa-eye" style={{ marginRight: "6px" }} />
            Preview
          </h5>
          <div className="preview-frame">
            {mSelectedStaff.length === 0 ? (
              <div className="no-staff-message">
                <i className="fa fa-user-plus" />
                <h4>No Staff Selected</h4>
                <p>Please select staff members to preview the offer letter</p>
              </div>
            ) : (
              <>
                {showPreview && <MyLoader />}
                <Iframe
                  ref={iframeRef}
                  src={FILE_URL}
                  width="100%"
                  height={height}
                  style={{ border: "none", overflow: "hidden" }}
                  id="iFrameOfferLetter"
                  scrolling="no"
                  onLoad={() => setShowPreview(false)}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {isOpenSelectStaff && (
        <MdlSelectMultipleStaff
          actionClose={HandleCloseSelectStaff}
          actionHandleSelected={HandleSelectedStaff}
        />
      )}
    </div>
  );
};

export default StaffOfferLetter;
